import { useState } from 'react';
import { getToken } from '../utils';
import axios from 'axios';
import ReactLoading from 'react-loading';
import { toast } from 'react-toastify';

const contactInfos = [
  {
    id: 1,
    icon: (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='25'
        height='25'
        viewBox='0 0 25 25'
        fill='none'
      >
        <path
          d='M12.3281 22.0742C12.3281 22.0742 5.62891 14.7148 5.62891 9.91797C5.62891 4.25781 9.33203 2.94922 12.3281 2.94922C15.0859 2.94922 18.6289 4.42969 18.6289 9.91797C18.6289 14.8711 12.3281 22.0742 12.3281 22.0742Z'
          stroke='#2C2F30'
        />
        <path
          d='M12.1289 11.3945C13.624 11.3945 14.8359 10.1826 14.8359 8.6875C14.8359 7.19245 13.624 5.98047 12.1289 5.98047C10.6339 5.98047 9.42188 7.19245 9.42188 8.6875C9.42188 10.1826 10.6339 11.3945 12.1289 11.3945Z'
          stroke='#2C2F30'
        />
      </svg>
    ),
    text: [
      '5B, Ladipo Omotesho Street, Lekki phase 1, Lagos, Nigeria.',
      '71-75 Shelton Street, Covent Garden, London, WC2H 9JQ, United Kingdom',
    ],
  },
  {
    id: 2,
    icon: (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='28'
        height='20'
        viewBox='0 0 28 20'
        fill='none'
      >
        <path
          d='M23.6938 3H4.09375C3.48969 3 3 3.34978 3 3.78125V16.1906C3 16.6221 3.48969 16.9719 4.09375 16.9719H23.6938C24.2978 16.9719 24.7875 16.6221 24.7875 16.1906V3.78125C24.7875 3.34978 24.2978 3 23.6938 3Z'
          stroke='#2C2F30'
        />
        <path d='M3 3L14.4672 10L25 3.2294' stroke='#2C2F30' />
      </svg>
    ),
    text: ['hello@loyaltyview.com', 'support@loyaltyview.com'],
  },
  {
    id: 3,
    icon: (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='25'
        height='25'
        viewBox='0 0 25 25'
        fill='none'
      >
        <path
          d='M20.2773 3.74609H4.72266C4.18332 3.74609 3.74609 4.18332 3.74609 4.72266V20.2773C3.74609 20.8167 4.18332 21.2539 4.72266 21.2539H20.2773C20.8167 21.2539 21.2539 20.8167 21.2539 20.2773V4.72266C21.2539 4.18332 20.8167 3.74609 20.2773 3.74609Z'
          stroke='#2C2F30'
        />
        <path d='M3.74609 8.04297H21.2539' stroke='#2C2F30' />
        <path d='M7.69531 3.74609V1.79297' stroke='#2C2F30' />
        <path d='M17.0547 3.74609V1.79297' stroke='#2C2F30' />
        <path
          d='M8.70703 10.9062H6.30469V13.3086H8.70703V10.9062Z'
          stroke='#2C2F30'
        />
        <path
          d='M13.6445 10.9062H11.2422V13.3086H13.6445V10.9062Z'
          stroke='#2C2F30'
        />
        <path
          d='M18.5195 10.9062H16.1172V13.3086H18.5195V10.9062Z'
          stroke='#2C2F30'
        />
        <path
          d='M8.79297 15.5H6.39062V17.9023H8.79297V15.5Z'
          stroke='#2C2F30'
        />
        <path d='M13.7344 15.5H11.332V17.9023H13.7344V15.5Z' stroke='#2C2F30' />
        <path d='M18.6094 15.5H16.207V17.9023H18.6094V15.5Z' stroke='#2C2F30' />
      </svg>
    ),
    text: ['Monday - Friday', 'Weekly'],
  },
  {
    id: 4,
    icon: (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='25'
        height='25'
        viewBox='0 0 25 25'
        fill='none'
      >
        <path
          d='M12.5 20.168C16.8924 20.168 20.4531 16.6072 20.4531 12.2148C20.4531 7.82245 16.8924 4.26172 12.5 4.26172C8.10761 4.26172 4.54688 7.82245 4.54688 12.2148C4.54688 16.6072 8.10761 20.168 12.5 20.168Z'
          stroke='#2C2F30'
        />
        <path
          d='M12.25 6.47656V12.4961L15.1406 14.7109'
          stroke='#2C2F30'
          strokeLinecap='round'
        />
        <path
          d='M5.32812 20.8711L7.12891 18.0859'
          stroke='#2C2F30'
          strokeLinecap='round'
        />
        <path
          d='M17.9062 18.0859L19.707 20.8711'
          stroke='#2C2F30'
          strokeLinecap='round'
        />
        <path
          d='M3.57412 7.57824C3.11599 7.1078 2.85962 6.47709 2.85962 5.82043C2.85962 5.16377 3.11599 4.53305 3.57412 4.06261C3.79666 3.83273 4.06314 3.64994 4.35774 3.5251C4.65233 3.40027 4.96901 3.33594 5.28896 3.33594C5.60892 3.33594 5.9256 3.40027 6.22019 3.5251C6.51479 3.64994 6.78127 3.83273 7.00381 4.06261L3.57412 7.57824Z'
          stroke='#2C2F30'
        />
        <path
          d='M21.4336 7.57824C21.8917 7.1078 22.1481 6.47709 22.1481 5.82043C22.1481 5.16377 21.8917 4.53305 21.4336 4.06261C21.2111 3.83273 20.9446 3.64994 20.65 3.5251C20.3554 3.40027 20.0387 3.33594 19.7187 3.33594C19.3988 3.33594 19.0821 3.40027 18.7875 3.5251C18.4929 3.64994 18.2264 3.83273 18.0039 4.06261L21.4336 7.57824Z'
          stroke='#2C2F30'
        />
      </svg>
    ),
    text: ['8:30am - 5pm', 'Five Days'],
  },
];

const initialData = {
  fullName: '',
  email: '',
  phoneNumber: '',
  subject: '',
  message: '',
};

function ContactUs() {
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState(initialData);

  const { token: userToken } = getToken();

  const handleChange = (e) => {
    const target = e.target;
    const { value, name } = target;
    setFormData((input) => ({
      ...input,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsLoading(true);
    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/dashboard/contact-us`,
        {
          name: formData.fullName,
          email: formData.email,
          phone: formData.phoneNumber,
          subject: formData.subject,
          message: formData.message,
        },
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
          },
        }
      );

      toast.success(data.message, {
        autoClose: 2000,
      });
      setFormData(initialData);
    } catch (error) {
      toast.error(`Request failed`, {
        autoClose: 3000,
      });
      console.log(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const contactFomData = [
    {
      id: 1,
      label: 'Full Name',
      type: 'text',
      name: 'fullName',
      value: formData.fullName,
      placeholder: '*************',
      disable: isLoading,
      onChange: handleChange,
    },
    {
      id: 2,
      label: 'Email',
      type: 'email',
      name: 'email',
      value: formData.email,
      placeholder: '*************',
      disable: isLoading,
      onChange: handleChange,
    },
    {
      id: 3,
      label: 'Phone Number',
      type: 'number',
      name: 'phoneNumber',
      value: formData.phoneNumber,
      placeholder: '*************',
      disable: isLoading,
      onChange: handleChange,
    },
    {
      id: 4,
      label: 'Subject',
      type: 'text',
      name: 'subject',
      value: formData.subject,
      placeholder: '*************',
      disable: isLoading,
      onChange: handleChange,
    },
    {
      id: 5,
      label: 'Message',
      type: 'textarea',
      name: 'message',
      value: formData.message,
      placeholder: '*************',
      disable: isLoading,
      onChange: handleChange,
    },
  ];

  return (
    <section className=''>
      <div className='font-semibold text-2xl text-center mb-12 flex flex-row gap-4 items-center justify-center bg-f-bk py-12 px-6 text-p-bk'>
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='28'
          height='28'
          viewBox='0 0 24 24'
          className='text-p-bk/70'
        >
          <path
            fill='currentColor'
            d='M21 6.3c0-.79-.47-1.51-1.19-1.83l-7-3.11c-.52-.23-1.11-.23-1.62 0l-7 3.11C3.47 4.79 3 5.51 3 6.3V11c0 5.55 3.84 10.74 9 12c2.3-.56 4.33-1.9 5.88-3.71l-3.12-3.12a4.994 4.994 0 0 1-6.29-.64a5.003 5.003 0 0 1 0-7.07a5.003 5.003 0 0 1 7.07 0a5.006 5.006 0 0 1 .64 6.29l2.9 2.9C20.29 15.69 21 13.38 21 11V6.3z'
          />
          <circle cx='12' cy='12' r='3' fill='currentColor' />
        </svg>
        <h2 className=''>Contact Us</h2>
      </div>
      <div className='px-6 xl:px-14 gap-20 flex flex-col pb-8'>
        <div>
          <h6 className='text-p-bk text-2xl font-semibold leading-7 mb-5'>
            Contact Information
          </h6>
          <p className='text-p-bk text-base font-normal leading-6'>
            For support, fill out the form and we will be InTouch as soon as
            possible
          </p>

          <ul className='mt-6 grid md:grid-cols-2 gap-7 text-p-bk'>
            {contactInfos.map((contactInfo) => (
              <li
                className='flex items-center gap-3 border rounded-md p-2 shadow-sm flex-col'
                key={contactInfo.id}
              >
                <i className='flex items-center justify-center w-[40px] h-[40px] shrink-0 shadow-sm rounded-full overflow-hidden'>
                  {contactInfo.icon}
                </i>
                <span className='flex flex-col gap-1 items-center text-center'>
                  {contactInfo.text?.map((info, index) => (
                    <p key={index}>{info}</p>
                  ))}
                </span>
              </li>
            ))}
          </ul>
        </div>
        <form className='w-full flex flex-col gap-4' onSubmit={handleSubmit}>
          <h6 className='text-p-bk text-2xl font-semibold leading-7 mb-3'>
            How can we assist you?
          </h6>
          <div className='grid md:grid-cols-2 gap-x-8 gap-y-4'>
            {contactFomData.map((contact) =>
              contact.type === 'textarea' ? (
                <fieldset
                  key={contact.id}
                  className='flex flex-col gap-1 col-span-2'
                >
                  <label className='text-p-bk text-base font-pin'>
                    {contact.label}
                  </label>
                  <textarea
                    className='focus:b-mc w-full min-h-[6rem] disabled:bg-f-bk rounded-lg border-t-bk border-hf px-4 py-1 focus:outline-none focus:ring focus:b-mc'
                    name={contact.name}
                    value={contact.value}
                    onChange={contact.onChange}
                    placeholder={contact.placeholder}
                    disabled={contact.disable}
                    required
                  ></textarea>
                </fieldset>
              ) : (
                <fieldset
                  key={contact.id}
                  className='flex flex-col gap-1 md:col-span-1 col-span-2'
                >
                  <label className='text-p-bk text-base font-pin'>
                    {contact.label}
                  </label>
                  <input
                    type={contact.type}
                    className=' focus:b-mc w-full h-11 disabled:bg-f-bk rounded-lg border-t-bk border-hf px-4 focus:outline-none focus:ring focus:b-mc'
                    name={contact.name}
                    value={contact.value}
                    onChange={contact.onChange}
                    placeholder={contact.placeholder}
                    disabled={contact.disable}
                    required
                  />
                </fieldset>
              )
            )}
          </div>

          <button
            className='text-p-wh justify-center disabled:text-f-bk hover:bg-b-mc/75 focus:bg-b-mc/80 px-8 py-2.5 w-fit font-semibold disabled:bg-b-mct bg-b-mc rounded-md'
            disabled={isLoading}
          >
            {!isLoading ? (
              'Send message'
            ) : (
              <ReactLoading
                type='cylon'
                color='#5AC8FA'
                height={44}
                width={44}
              />
            )}
          </button>
        </form>
      </div>
    </section>
  );
}

export default ContactUs;
